<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aAWU0S/tc-custom/9781615954193.jpg?1731805815396" alt="This image is the cover for the book Death in the 12th House, Starlight Detective Agency Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death in the 12th House, Starlight Detective Agency Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Astrologically inclined cozy fans will find a lot to like."—<i>Publishers Weekly</i></b></p><p>Someone is bumping off rock's wrinkled royalty. The latest victim? Freddie Finger, 63-year-old lead singer for Rocket Fire. Seeking answers, Freddie's daughter, movie actress Vivian Younger, retains astrologer detective David Lowell to help catch her father's killer.</p><p>Freddie wasn't well liked, and Lowell has plenty of suspects. Among them are Freddie's ex-wives, who seem more intent on killing each other than anyone else. And his disgruntled band members, angry because Freddie's solo career was threatening the band's future. Then there is his greedy manager, busy promoting the death of a rock star. Or could his killer have been the musician whose career Freddie sabotaged many years ago?</p><p>With the help of his red-haired assistant Sarah, master hacker and psychic Mort, and his driver and bodyguard Andy, Lowell sifts through the birth charts of the characters and follows the clues to a surprising ending.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mitchell Scott Lewis
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6bd97b04